




































import gql from 'graphql-tag';
import Vue from 'vue';

import { Client, ClientProduct } from '@/core/entity';
import CategoryInput from '@/vue/components/input/Category.vue';
import ProductInput from '@/vue/components/input/Product.vue';

export default Vue.extend({
  components: {
    'input-category': CategoryInput,
    'input-product': ProductInput,
  },

  props: {
    client: Object as () => Client,
    loading: Boolean as () => boolean,
    product: Object as () => ClientProduct,
  },

  data() {
    const { product } = this;
    return {
      category: undefined as string | undefined,
      intrackProduct: (product && product.intrackProduct
        ? product.intrackProduct.id
        : undefined) as string | undefined,
    };
  },

  computed: {
    country(): string | null {
      return this.client ? this.client.country : null;
    },

    title(): string {
      if (this.product) {
        return `[${this.product.id}] ${this.product.name}`;
      }
      return '';
    },
  },

  methods: {
    handleSubmit() {
      const { intrackProduct, product } = this;
      const clientProductId = product.id.split(':')[1];

      if (intrackProduct) {
        this.$emit('submit', {
          client: clientProductId,
          intrack: intrackProduct,
        });
      }
    },
  },
});
